import { render, staticRenderFns } from "./modalEditAutomatedNotificationAttributes.vue?vue&type=template&id=3bf53143&"
import script from "./modalEditAutomatedNotificationAttributes.vue?vue&type=script&lang=js&"
export * from "./modalEditAutomatedNotificationAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports